/*
 * étonné 2027 四柱推命×ラッキーカラー診断
 * core engine v1.0
 * Requires local lunar-javascript v1.7.7 (global Solar).
 * No network calls. Birth data stays in the visitor's browser.
 */
(function(root){
'use strict';

var STEM={
 '甲':{element:'木',polarity:'陽',reading:'きのえ'},'乙':{element:'木',polarity:'陰',reading:'きのと'},
 '丙':{element:'火',polarity:'陽',reading:'ひのえ'},'丁':{element:'火',polarity:'陰',reading:'ひのと'},
 '戊':{element:'土',polarity:'陽',reading:'つちのえ'},'己':{element:'土',polarity:'陰',reading:'つちのと'},
 '庚':{element:'金',polarity:'陽',reading:'かのえ'},'辛':{element:'金',polarity:'陰',reading:'かのと'},
 '壬':{element:'水',polarity:'陽',reading:'みずのえ'},'癸':{element:'水',polarity:'陰',reading:'みずのと'}
};

var HIDDEN={
 '子':['癸'],'丑':['己','癸','辛'],'寅':['甲','丙','戊'],'卯':['乙'],'辰':['戊','乙','癸'],
 '巳':['丙','戊','庚'],'午':['丁','己'],'未':['己','丁','乙'],'申':['庚','壬','戊'],
 '酉':['辛'],'戌':['戊','辛','丁'],'亥':['壬','甲']
};

var ELEMENTS=['木','火','土','金','水'];

var GENERATES={
 '木':'火','火':'土','土':'金','金':'水','水':'木'
};

var GENERATED_BY={
 '木':'水','火':'木','土':'火','金':'土','水':'金'
};

var CONTROLS={
 '木':'土','土':'水','水':'火','火':'金','金':'木'
};

var COLOR={
 '木':'アップルグリーン',
 '丙':'レッド',
 '丁':'キティピンク',
 '土':'ソルイエロー',
 '金':'アッシュグレージュ',
 '水':'ターコイズブルー'
};

var COLOR_ID={
 'アップルグリーン':'apple-green-2027',
 'レッド':'red-2027',
 'キティピンク':'kitty-pink-2027',
 'ソルイエロー':'sol-yellow-2027',
 'アッシュグレージュ':'ash-greige-2027',
 'ターコイズブルー':'turquoise-blue-2027'
};

var STEM_WEIGHT={
 year:.80,
 month:1.10,
 day:1.20,
 time:.90
};

var BRANCH_WEIGHT={
 year:.80,
 month:1.60,
 day:1.10,
 time:.90
};

var HIDDEN_WEIGHT=[1,.35,.20];

var SEASON={
 '寅':{木:1.50,火:1.10,水:.90,土:.85,金:.65},
 '卯':{木:1.60,火:1.10,水:.90,土:.80,金:.60},
 '辰':{土:1.25,木:1.20,水:.85,火:1.00,金:.75},
 '巳':{火:1.50,土:1.15,木:1.00,金:.80,水:.55},
 '午':{火:1.60,土:1.15,木:.90,金:.75,水:.50},
 '未':{土:1.30,火:1.20,木:.90,金:.80,水:.65},
 '申':{金:1.50,水:1.10,土:1.00,火:.70,木:.55},
 '酉':{金:1.60,水:1.10,土:.90,火:.65,木:.50},
 '戌':{土:1.30,金:1.10,火:.90,木:.70,水:.75},
 '亥':{水:1.50,木:1.10,金:.90,土:.70,火:.55},
 '子':{水:1.60,木:1.10,金:.90,土:.65,火:.50},
 '丑':{土:1.30,水:1.20,金:.90,木:.70,火:.60}
};

var CLIMATE={
 '寅':{金:.35,火:.15},
 '卯':{金:.40,火:.15},
 '辰':{木:.20,水:.10},
 '巳':{水:.90,金:.35},
 '午':{水:1.10,金:.35},
 '未':{水:.75,金:.25},
 '申':{火:.35,水:.15},
 '酉':{火:.45,水:.15},
 '戌':{木:.20,水:.15},
 '亥':{火:.90,土:.25},
 '子':{火:1.10,土:.30},
 '丑':{火:.75,木:.15}
};

function relation(dayElement,otherElement){
 if(otherElement===dayElement)return 'companion';
 if(GENERATES[otherElement]===dayElement)return 'resource';
 if(GENERATES[dayElement]===otherElement)return 'output';
 if(CONTROLS[dayElement]===otherElement)return 'wealth';
 if(CONTROLS[otherElement]===dayElement)return 'officer';
 return 'other';
}

function mean(v){
 var s=0;
 for(var i=0;i<v.length;i++)s+=v[i];
 return s/v.length;
}

function pstdev(v){
 var m=mean(v),s=0;
 for(var i=0;i<v.length;i++)s+=Math.pow(v[i]-m,2);
 return Math.sqrt(s/v.length)||1;
}

function clamp(v,lo,hi){
 return Math.max(lo,Math.min(hi,v));
}

function shiftMinutes(p,minutes){
 var dt=new Date(
   Date.UTC(
     p.year,
     p.month-1,
     p.day,
     p.hour||0,
     p.minute||0,
     0
   )
 );

 dt.setUTCMinutes(dt.getUTCMinutes()+minutes);

 return {
   year:dt.getUTCFullYear(),
   month:dt.getUTCMonth()+1,
   day:dt.getUTCDate(),
   hour:dt.getUTCHours(),
   minute:dt.getUTCMinutes()
 };
}

function splitPillar(gz){
 return {
   gan:gz.charAt(0),
   zhi:gz.charAt(1)
 };
}

function extractPillars(input){

 if(typeof root.Solar==='undefined'){
   throw new Error('暦計算ファイルが読み込まれていません。');
 }

 var hasTime=
   Number.isInteger(input.hour) &&
   input.hour>=0;

 var h=hasTime ? input.hour : 12;

 var mi=
   hasTime &&
   Number.isInteger(input.minute)
   ? input.minute
   : 0;

 var localSolar=
   root.Solar.fromYmdHms(
     input.year,
     input.month,
     input.day,
     h,
     mi,
     0
   );

 var localLunar=
   localSolar.getLunar();

 /*
  lunar-javascript の節気時刻は北京時間基準。

  日本出生の場合は、
  年柱・月柱の節入り境界判定だけ
  同一瞬間のCSTへ60分戻して判定する。
 */
 var bp=
   input.japanTime===false
   ? {
       year:input.year,
       month:input.month,
       day:input.day,
       hour:h,
       minute:mi
     }
   : shiftMinutes(
       {
         year:input.year,
         month:input.month,
         day:input.day,
         hour:h,
         minute:mi
       },
       -60
     );

 var boundaryLunar=
   root.Solar.fromYmdHms(
     bp.year,
     bp.month,
     bp.day,
     bp.hour,
     bp.minute,
     0
   ).getLunar();

 var year=
   splitPillar(
     boundaryLunar.getYearInGanZhiExact()
   );

 var month=
   splitPillar(
     boundaryLunar.getMonthInGanZhiExact()
   );

 /*
  晩子時は当日扱い
  sect 2
 */
 var dayGz=
   typeof localLunar.getDayInGanZhiExact2==='function'
   ? localLunar.getDayInGanZhiExact2()
   : localLunar.getDayInGanZhiExact();

 var day=
   splitPillar(dayGz);

 var time=
   hasTime
   ? splitPillar(
       localLunar.getTimeInGanZhi()
     )
   : null;

 return {
   year:year,
   month:month,
   day:day,
   time:time,
   hasTime:hasTime
 };
}

function rawPower(pillars){

 var sp={};

 var ep={
   木:0,
   火:0,
   土:0,
   金:0,
   水:0
 };

 Object.keys(STEM).forEach(function(s){
   sp[s]=0;
 });

 ['year','month','day','time']
 .forEach(function(pos){

   var p=pillars[pos];

   if(!p)return;

   sp[p.gan]+=STEM_WEIGHT[pos];

   ep[STEM[p.gan].element]+=
     STEM_WEIGHT[pos];

   (HIDDEN[p.zhi]||[])
   .forEach(function(g,i){

     var w=
       BRANCH_WEIGHT[pos] *
       (HIDDEN_WEIGHT[i]||.15);

     sp[g]+=w;

     ep[STEM[g].element]+=w;

   });

 });

 var seasonal={};

 var mz=pillars.month.zhi;

 ELEMENTS.forEach(function(e){

   seasonal[e]=
     ep[e] *
     SEASON[mz][e];

 });

 return {
   stemPower:sp,
   elementPower:seasonal
 };
}

function normalizeElements(ep){

 var total=0;
 var out={};

 ELEMENTS.forEach(function(e){
   total+=ep[e];
 });

 ELEMENTS.forEach(function(e){

   out[e]=
     total
     ? Math.round(
         ep[e]/total*100
       )
     : 0;

 });

 /*
  四捨五入で99/101になった場合は
  最大要素へ差分を加えて100に補正
 */
 var sum=
   ELEMENTS.reduce(
     function(s,e){
       return s+out[e];
     },
     0
   );

 if(sum!==100){

   var max=ELEMENTS[0];

   ELEMENTS.forEach(function(e){
     if(ep[e]>ep[max])max=e;
   });

   out[max]+=100-sum;
 }

 return out;
}

function analyzePillars(pillars){

 var base=
   rawPower(pillars);

 var sp=
   Object.assign(
     {},
     base.stemPower
   );

 var ep=
   Object.assign(
     {},
     base.elementPower
   );

 var projected=
   Object.assign(
     {},
     ep
   );

 /*
  2027 丁未を弱い係数で加える
 */
 projected['火']+=.28;

 HIDDEN['未']
 .forEach(function(g,i){

   projected[STEM[g].element]+=
     .22 *
     (HIDDEN_WEIGHT[i]||.15);

 });

 var dm=
   pillars.day.gan;

 var dmElement=
   STEM[dm].element;

 var total=
   ELEMENTS.reduce(
     function(s,e){
       return s+ep[e];
     },
     0
   ) || .0001;

 var support=
   (
     ep[dmElement] +
     .88 *
     ep[GENERATED_BY[dmElement]]
   ) /
   total;

 var strength=
   support>=.56
   ? 'strong'
   : (
       support<=.36
       ? 'weak'
       : 'balanced'
     );

 var prefMap={
   weak:{
     resource:1.45,
     companion:1.35,
     output:-.35,
     wealth:-.55,
     officer:-.70
   },

   balanced:{
     resource:.18,
     companion:.12,
     output:.38,
     wealth:.30,
     officer:.22
   },

   strong:{
     resource:-.50,
     companion:-.65,
     output:1.35,
     wealth:1.20,
     officer:1.05
   }

 }[strength];

 var values=
   ELEMENTS.map(function(e){
     return projected[e];
   });

 var avg=
   mean(values);

 var sd=
   pstdev(values);

 var mz=
   pillars.month.zhi;

 var affinity={
   木:.22,
   火:.36,
   土:.55
 };

 var scores={};

 ELEMENTS.forEach(function(e){

   var deficit=
     clamp(
       (avg-projected[e])/sd,
       -2.2,
       2.2
     ) * .82;

   var rel=
     relation(
       dmElement,
       e
     );

   var pref=
     prefMap[rel]||0;

   var climate=
     (
       (
         CLIMATE[mz] &&
         CLIMATE[mz][e]
       ) ||
       0
     ) * .72;

   scores[e]=
     deficit +
     pref +
     climate +
     (
       pref>=0
       ? (affinity[e]||0)
       : 0
     );

 });

 var selected=
   ELEMENTS[0];

 ELEMENTS.forEach(function(e){

   if(scores[e]>scores[selected]){
     selected=e;
   }

 });

 var selectedStem=null;

 /*
  火が選ばれた時だけ
  レッド / キティピンクを分ける
 */
 if(selected==='火'){

   var yang=
     sp['丙'];

   var yin=
     sp['丁'];

   var redBias=
     (mz==='亥'||mz==='子')
     ? .35
     : (
         mz==='丑'
         ? .22
         : (
             (mz==='申'||mz==='酉')
             ? .10
             : 0
           )
       );

   var pinkBias=.18;

   if(dm==='丁'){
     pinkBias+=.14;
   }

   if(dm==='丙'){
     redBias+=.10;
   }

   var redScore=
     (
       (yin-yang)/
       (yin+yang+1)
     )*.36 +
     redBias;

   var pinkScore=
     (
       (yang-yin)/
       (yang+yin+1)
     )*.36 +
     pinkBias;

   selectedStem=
     redScore>=pinkScore
     ? '丙'
     : '丁';
 }

 var color=
   selected==='火'
   ? COLOR[selectedStem]
   : COLOR[selected];

 return {

   dayMaster:dm,

   dayMasterInfo:
     STEM[dm],

   strength:strength,

   supportRatio:support,

   elementPower:ep,

   elementPercent:
     normalizeElements(ep),

   selectedElement:
     selected,

   selectedStem:
     selectedStem,

   color:color,

   colorAnchor:
     COLOR_ID[color],

   hasTime:
     !!pillars.time,

   pillars:
     pillars

 };
}

function diagnose(input){

 var pillars=
   extractPillars(input);

 return analyzePillars(
   pillars
 );
}

root.ETONNE_SHICHUSUIMEI_2027={

 version:'1.0.0',

 diagnose:
   diagnose,

 extractPillars:
   extractPillars,

 analyzePillars:
   analyzePillars,

 constants:{
   STEM:STEM,
   COLOR_ID:COLOR_ID
 }

};

})(
 typeof window!=='undefined'
 ? window
 : this
);